module.exports = __webpack_public_path__ + "static/img/mini-bus-yellow.18b2ebb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-yellow.svg
// module id = thLz
// module chunks = 82